// Bangle Bloom — Theme JavaScript

// Countdown Timer
function startCountdown() {
  const end = new Date();
  end.setHours(23, 59, 59, 0);

  function update() {
    const now = new Date();
    const diff = end - now;
    if (diff <= 0) return;

    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    const el = (id, val) => {
      const e = document.getElementById(id);
      if (e) e.textContent = String(val).padStart(2, '0');
    };
    el('cd-hours', h);
    el('cd-minutes', m);
    el('cd-seconds', s);
  }
  update();
  setInterval(update, 1000);
}

// Add to Cart
function addToCart(productId, title, price) {
  let cart = JSON.parse(localStorage.getItem('bb_cart') || '[]');
  const existing = cart.find(i => i.id === productId);
  if (existing) {
    existing.qty += 1;
  } else {
    cart.push({ id: productId, title, price, qty: 1 });
  }
  localStorage.setItem('bb_cart', JSON.stringify(cart));
  updateCartCount();
  showToast(`${title} added to cart!`);
}

function updateCartCount() {
  const cart = JSON.parse(localStorage.getItem('bb_cart') || '[]');
  const count = cart.reduce((sum, i) => sum + i.qty, 0);
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'inline-flex' : 'none';
  });
}

// Toast notification
function showToast(msg) {
  let toast = document.getElementById('bb-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'bb-toast';
    toast.style.cssText = `
      position: fixed; bottom: 28px; right: 28px;
      background: #2c1810; color: #d4af37;
      padding: 14px 24px; border-radius: 10px;
      font-weight: 700; font-size: 14px;
      box-shadow: 0 8px 32px rgba(0,0,0,0.25);
      z-index: 9999; opacity: 0;
      transition: opacity 0.3s;
      border-left: 4px solid #d4af37;
    `;
    document.body.appendChild(toast);
  }
  toast.textContent = '🛍️ ' + msg;
  toast.style.opacity = '1';
  setTimeout(() => toast.style.opacity = '0', 2800);
}

// Newsletter form
function setupNewsletter() {
  const form = document.getElementById('newsletter-form');
  if (!form) return;
  form.addEventListener('submit', e => {
    e.preventDefault();
    showToast('Thank you for subscribing!');
    form.reset();
  });
}

// Sticky header shadow
function setupHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.style.boxShadow = window.scrollY > 10
      ? '0 4px 20px rgba(0,0,0,0.12)'
      : '0 2px 12px rgba(0,0,0,0.07)';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  startCountdown();
  updateCartCount();
  setupNewsletter();
  setupHeader();
});
